export default __webpack_public_path__ + "static/media/feature3.459af06a.png";